module.exports = __webpack_public_path__ + "static/media/18ECA5.4d89b5ef.jpg";